<script setup lang="ts">
type Props = {
  item: {
    key?: string;
    title?: string;
  };
};

const props = defineProps<Props>();

const { t } = useI18n();
const title = computed(() => {
  if (props.item.title) {
    return props.item.title;
  }
  switch (props.item.key) {
    case "parent_own":
      return t("bookshelf.chronic.filter.own");
    case "parent_other":
      return t("bookshelf.chronic.filter.others");
    case "lexmea_schemas":
      return t("bookshelf.content.keywords.lexmea_schemata");
    case "own_schemas":
      return t("bookshelf.content.keywords.own_schemata");
    default:
      return t(`entries.${props.item.key}`, 9);
  }
});
</script>

<template>
  {{ title }}
</template>
